import React from 'react';

const SummaryCard = ({ label, total, count, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-white border-gray-200',
    danger: 'bg-red-50 border-red-200',
    warning: 'bg-yellow-50 border-yellow-200',
    success: 'bg-green-50 border-green-200',
    info: 'bg-blue-50 border-blue-200',
  };

  const formattedTotal = new Intl.NumberFormat('el-GR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(total);

  return (
    <div className={`rounded-lg border p-4 shadow-sm ${variantStyles[variant]}`}>
      <div className="text-sm font-medium text-gray-600">{label}</div>
      <div className="mt-1 flex items-baseline justify-between">
        <span className="text-xl font-semibold text-gray-900">{formattedTotal} €</span>
        <span className="text-sm text-gray-500">{count} τεμ.</span>
      </div>
    </div>
  );
};

export default SummaryCard;
